export default __webpack_public_path__ + "static/media/australia_flag.513e8364.png";